import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay/hooks'
import { FlexColumn, RouterLink } from 'elements'
import ChoiceButton from 'components/ui/input/ChoiceButton'

export default function SwitchOrgsList({ closeModal, selectedOrg }) {
  const data = useLazyLoadQuery(
    graphql`
      query SwitchOrgsListQuery {
        currentUser {
          organizationUsers {
            nodes {
              organization {
                id
                name
                slug
              }
            }
          }
        }
      }
    `,
  )

  const orgs = data.currentUser.organizationUsers.nodes.map((node) => node.organization)

  return (
    <FlexColumn>
      {orgs.map((org) => (
        <ChoiceButton
          key={org.id}
          icon="globe-alt"
          as={RouterLink}
          to={`/orgs/${org.slug}/companies`}
          mb="small"
          selected={org.id === selectedOrg?.id}
          onClick={closeModal}
        >
          {org.name}
        </ChoiceButton>
      ))}
    </FlexColumn>
  )
}
